exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-danger[data-v-3c905919]{border:1px solid #f56c6c;border-radius:2px}.blank-multiple-question[data-v-3c905919]{position:relative}.blank-multiple-question .text[data-v-3c905919]{color:#8f959e;margin:8px 0}", ""]);

// exports
